import React from 'react';
import styled from 'styled-components';
import { Container as BaseContainer, topBorder, buttonBase } from './GlobalStyle';
import { useI18n } from '../i18n';

const Section = styled.section`
  padding: 4rem 2rem;
  background: ${({ theme }) => theme.colors.bg};
  ${topBorder}
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 3rem 1rem;
  }
`;

const Container = styled(BaseContainer)`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  align-items: center;
  gap: 1.5rem;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.brandDark};
  font-size: 1.4rem;
  font-weight: 800;
`;

const Sub = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  margin: 0.5rem 0 0;
  max-width: 520px;
`;

const DisabledButton = styled.span`
  ${buttonBase}
  background: ${({ theme }) => theme.colors.brandTint};
  color: ${({ theme }) => theme.colors.muted};
  width: fit-content;
  cursor: not-allowed;
  &:active {
    transform: none;
  }
`;

const MeetTeam = () => {
  const { t } = useI18n();
  return (
    <Section>
      <Container>
        <div>
          <Title>{t('home.meetTeamText')}</Title>
          <Sub>{t('home.meetTeamSub')}</Sub>
        </div>
        <DisabledButton aria-disabled="true">{t('home.meetTeamCta')}</DisabledButton>
      </Container>
    </Section>
  );
};

export default MeetTeam;
